var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',[_vm._v("Reviews")]),_c('hr'),_c('ReviewsTable',{attrs:{"organization":_vm.organization,"filterOptions":_vm.filterOptions,"reviews":_vm.reviews},on:{"edit":_vm.editReview}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }